export const CALL_CENTER = {
  hidden: true,
  label: 'Call Center (deprecated)',
  value: 'call-center',
  navigationLimit: 5,
  tabs: ['branding', 'integrations'],
  authOptions: [{ label: 'None', value: 'none' }],
}
